var _circle, _g, _g2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLfw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_3035:8787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9.38607H20.13V9.38607C20.13 8.63869 20.7718 8.05266 21.5161 8.12039L22.315 8.19309L23.791 7.3872C24.234 7.14533 24.7685 7.1406 25.2157 7.3746L26.4 7.99426H27.5262C28.2074 7.99426 28.8045 8.45014 28.9839 9.10737L29.06 9.38607H34V38.6141H29.25L28.8225 39.8071H26.875L24.5 41.0001L22.1725 39.8071H19.845L18.99 38.6141H15V9.38607Z",
    fill: "#183C48"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_3035:8787)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4 7.99426L25.2157 7.3746C24.7685 7.1406 24.234 7.14533 23.791 7.3872L22.315 8.19309L21.5161 8.12039C20.7718 8.05266 20.13 8.63869 20.13 9.38607H15V38.6141H18.99L19.845 39.8071H22.1725L24.5 41.0001L26.875 39.8071H28.8225L29.25 38.6141H34V9.38607H29.06L28.9839 9.10737C28.8045 8.45014 28.2074 7.99426 27.5262 7.99426H26.4ZM33.2444 10.1416H28.4831L28.255 9.30637C28.1653 8.97775 27.8668 8.74981 27.5262 8.74981H26.2143L24.8654 8.04405C24.6418 7.92705 24.3746 7.92942 24.1531 8.05035L22.4754 8.96636L21.4476 8.87284C21.1458 8.84537 20.8856 9.08301 20.8856 9.38607H20.13V10.1416H15.7556V37.8586H19.3781L20.2331 39.0516H22.3549L24.5035 40.1529L26.6959 39.0516H28.2906L28.7181 37.8586H33.2444V10.1416Z",
    fill: "#FFC472"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4044 25.4009H18.04L20.4044 34.955H22.7689L24.12 30.1779L25.4711 34.955H27.4978L30.2 25.4009H28.1733L26.4844 30.8604L24.7955 25.4009H23.4444L22.0933 30.8604L20.4044 25.4009Z",
    fill: "#4DDCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.04 13.7998H20.7422V21.9891H27.4978V24.7188H18.04V13.7998Z",
    fill: "#4DDCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4445 13.7998H30.2V15.1647H25.4711V17.2119H28.8489V18.5767H25.4711V21.9889H23.4445V18.5767V17.2119V15.1647H23.4445V13.7998Z",
    fill: "#4DDCE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.36 36.2781L24.5 35.7114L25.64 36.2781V39.6781L24.5 40.2448L23.36 39.6781V36.2781Z",
    fill: "#6AF2F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0578 36.0909L24.5 35.374L25.9422 36.0909V39.8655L24.5 40.5824L23.0578 39.8655V36.0909ZM23.36 39.6782V36.2782L24.5 35.7115L25.64 36.2782V39.6782L24.5 40.2449L23.36 39.6782Z",
    fill: "#E3AA5B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_3035:8787",
    x: 15,
    y: 7.20239,
    width: 19,
    height: 36.8198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.755556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.588235 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3035:8787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3035:8787",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.02222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3035:8787"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_3035:8787",
    x: 15,
    y: 7.20239,
    width: 19,
    height: 36.8198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.755556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.588235 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3035:8787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3035:8787",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.02222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3035:8787"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLfw);
export default __webpack_public_path__ + "static/media/lfw.46759ae0f0815a96d62f004b3cf99a7f.svg";
export { ForwardRef as ReactComponent };